import { Button, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";

import Context from "../../context";

// ----------------------------------------------------------------------

export const EntitiesSelectedRow = () => {
	const { state, actions } = useContext(Context);
	const { translate } = useLocales();

	const isCustom = state.selectedConfig === "CUSTOM";

	return (
		<Stack flexDirection={"row"} alignItems={"center"} gap={1}>
			<Typography variant='body1' fontSize={13}>
				{translate("app_config.saved_entities", { entities: state.entitiesSelected?.length })}
			</Typography>
			<Button
				disabled={!isCustom}
				variant='text'
				size='small'
				onClick={(e) => {
					actions.showSelectEntitiesDialog();
					e.stopPropagation();
				}}
				sx={{ opacity: isCustom ? 1 : 0 }}
			>
				{translate("app_config.edit")}
			</Button>
		</Stack>
	);
};

export default EntitiesSelectedRow;
